// extracted by mini-css-extract-plugin
export default {"spinner":"spinner_spinner__703bi","spin":"spinner_spin__RaNeO","marginVertical":"spinner_marginVertical__EDTIB","noTextContainer":"spinner_noTextContainer__Xe6mu"};